"use client";

import { Button, Tooltip, Typography } from "@kyan/ui";

import { EquityModal } from "./components/EquityModal/EquityModal";
import { useDepositController } from "./Deposit.controller";

export const Deposit = () => {
  const { isLg, title, tooltip, isDisabled, setShowEquityModal } =
    useDepositController();

  return (
    <div className="border-divider flex h-full items-center justify-center lg:border-l lg:px-4 xl:max-2xl:px-3">
      <Tooltip
        avoidCollisions
        side="right"
        align="center"
        className="z-10"
        disabled={!tooltip}
        content={<Typography size={12}>{tooltip}</Typography>}
      >
        <Button
          variant="secondary"
          disabled={isDisabled}
          size={isLg ? "md" : "sm"}
          data-testid="deposit-button"
          onClick={() => {
            setShowEquityModal(true);
          }}
        >
          {title}
        </Button>
      </Tooltip>
      <EquityModal />
    </div>
  );
};
